import React from 'react';
import { StyledSvg, iconGenerator } from '../Icon';
const AdminReversedIcon = ({ size, color, }) => (React.createElement(StyledSvg, { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", size: size },
    React.createElement("g", { fill: "none", fillRule: "evenodd" },
        React.createElement("path", { d: "M.5 0h24v24H.5z" }),
        React.createElement("path", { fill: color, fillRule: "nonzero", d: "M16.129 19.695l-1.232 2.262-6.136.02 4.117-7.483 3.25 5.2zM19.006 22l-5.366-8.892 2.442-4.441L23.632 22h-4.626zM12.183 2l3.188 5.48-8.183 14.5L.5 22 12.183 2z" }))));
export const AdminReversed = iconGenerator(AdminReversedIcon);
//# sourceMappingURL=AdminReversed.js.map